const scopes = {
  defaultScope: {},
};

// options could be either Handlebars options or scope String
const set = (key, value, opts) => {
  let options = opts;
  let hash;
  let data;
  let scope;
  let scopeObj;

  if (options && typeof options === 'string') {
    scope = options;
    data = {};
  } else {
    options = options || {};

    hash = options.hash || {};
    data = options.data || {};
    scope = hash.scope;
  }

  // If scope is provided use it otherwise use following logic
  if (!scope) {
    // if templateScope is available use it
    if (data.templateScope) {
      scopeObj = data.templateScope;
    } else {
      scope = 'defaultScope';
    }
  }

  if (!scopeObj) {
    scopeObj = scopes[scope] || (scopes[scope] = {});
  }

  scopeObj[key] = value;
};

const get = (key, options = {}) => {
  if (!key) {
    return undefined;
  }

  const data = options.data || {};
  let parts;
  let scope;

  if (key.indexOf('.') !== -1) {
    parts = key.split('.');
    scope = scopes[parts[0]];

    return scope ? scope[parts[1]] : undefined;
  }

  return data.templateScope ? data.templateScope[key] : scopes.defaultScope[key];
};

module.exports = {
  get,
  set,
};
